export default __webpack_public_path__ + "static/illustration-content-diagram.url-deec4fd86df27ff971da54456e30fba5.svg";